import CARD_LIST_TYPES from '../../composable-components/ComposableCardList/enum/cardListContentTypes';
import CARD_LIST_VIEW_TYPES from '../../composable-components/ComposableCardList/enum/cardListViewTypes';
/* eslint-disable no-underscore-dangle */
import FEATURE_FLAGS from './featureFlags';
import TYPENAMES from './typeNames';

const getFeatureName = (element) => {
  if (element.__typename === TYPENAMES.embeddedMedia) {
    return FEATURE_FLAGS.embeddedMedia;
  }

  if (
    element.__typename === TYPENAMES.cardList &&
    element.contentType === CARD_LIST_TYPES.media &&
    CARD_LIST_VIEW_TYPES.info === element.viewType
  ) {
    return FEATURE_FLAGS.infoCardList;
  }

  if (
    element.__typename === TYPENAMES.cardList &&
    element.contentType === CARD_LIST_TYPES.media
  ) {
    return FEATURE_FLAGS.mediaCardList;
  }

  if (
    element.__typename === TYPENAMES.cardList &&
    element.contentType === CARD_LIST_TYPES.article
  ) {
    return FEATURE_FLAGS.articleCardList;
  }

  if (element.__typename === TYPENAMES.topBar) {
    return FEATURE_FLAGS.topBar;
  }

  if (element.__typename === TYPENAMES.brandHeader) {
    return FEATURE_FLAGS.brandHeader;
  }

  if (element.__typename === TYPENAMES.brandNavigation) {
    return FEATURE_FLAGS.brandNavigation;
  }

  if (element.__typename === TYPENAMES.brandTitleBar) {
    return FEATURE_FLAGS.brandTitleBar;
  }

  if (element.__typename === TYPENAMES.subNavigation) {
    return FEATURE_FLAGS.subNavigation;
  }

  if (element.__typename === TYPENAMES.themeSubNavigation) {
    return FEATURE_FLAGS.themeSubNavigation;
  }

  if (element.__typename === TYPENAMES.sterBanner) {
    return FEATURE_FLAGS.sterBanner;
  }

  if (element.__typename === TYPENAMES.comments) {
    return FEATURE_FLAGS.comments;
  }

  if (element.__typename === TYPENAMES.newsletterSubscription) {
    return FEATURE_FLAGS.newsletterSubscription;
  }

  if (element.__typename === TYPENAMES.recommendationList) {
    return FEATURE_FLAGS.recommendationList;
  }

  if (element.__typename === TYPENAMES.popularRecommendationList) {
    return FEATURE_FLAGS.popularRecommendationList;
  }

  if (element.__typename === TYPENAMES.popularByBrandRecommendationList) {
    return FEATURE_FLAGS.popularByBrandRecommendationList;
  }

  if (element.__typename === TYPENAMES.relatedByThemeRecommendationList) {
    return FEATURE_FLAGS.relatedByThemeRecommendationList;
  }

  return null;
};

export default getFeatureName;
